import React from 'react'
import './loading-style.css'

export default function Loading({ description }) {
    return (
        <div style={{ margin: "100px auto", textAlign: "center" }}>
            <span class="loader"></span>
            <b style={{ color: "#3A3A3A" }}><h2 style={{ marginBottom: "50px" }}>{description}</h2></b>
        </div>
    )
}
